import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XIcon } from "lucide-react";
import { useState } from "react";
import { DashboardMenuItem } from "./DashboardMenuItem";
import { DashboardMenuRoleSwitcher } from "./DashboardMenuRoleSwitcher";
import logoConfiancia from "assets/images/logos/logo-main-simple.svg";
import { useMenuLogo } from "./useMenuLogo";
import { useVisibleMenuItems } from "./useVisibleMenuItems";

export default function MobileMenu({
  isCollapsed,
  onClose,
}: {
  isCollapsed: boolean;
  onClose: () => void
}) {
  const { logo } = useMenuLogo()
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  // Filtrage partagé avec le menu desktop (useVisibleMenuItems) : le mobile applique
  // désormais aussi les règles courtierOnly/compagnieOnly et le filtrage des enfants.
  const { visibleItems } = useVisibleMenuItems();

  return (
    <Transition show={isCollapsed}>
      <Dialog className="relative z-50 lg:hidden" onClose={onClose}>
        <TransitionChild
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900/80" />
        </TransitionChild>

        <div className="fixed inset-0 flex">
          <TransitionChild
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <DialogPanel className="relative mr-16 flex w-full max-w-xs flex-1">
              <TransitionChild
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute left-full top-0 flex -ml-16 w-16 justify-center pt-5">
                  <button
                    type="button"
                    className="-m-2.5 p-2.5"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XIcon
                      className="h-6 w-6 text-primary hover:text-primary/80"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </TransitionChild>
              <div className="flex flex-col grow">
                <div className="flex h-16 shrink-0 items-center bg-white p-4">
                  {logo != null && (
                    <img
                      className=""
                      src={logo !== "" ? logo : logoConfiancia}
                      alt="logo complet"
                    />
                  )}
                </div>
              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-primary p-6">
                <nav className="flex flex-1 flex-col">
                  <ul className="-mx-2 space-y-1">
                    {visibleItems.map((item, index) => (
                      <DashboardMenuItem
                        key={item.id}
                        item={item}
                        isCollapsed={false}
                        isHovered={hoveredItem === item.id}
                        onHover={setHoveredItem}
                      />
                    ))}
                  </ul>
                </nav>
                <DashboardMenuRoleSwitcher isCollapsed={false} />
              </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
